export default defineAppConfig({
  rokkaHost: '',
})
